import { SwanAssetFolders, SwanPathTypeEnum } from '../types/enums.js';
import { isTestEnv } from './env.utils.js';
import { SWAN_PUBLIC_ASSET_FOLDER, SWAN_VERSIONED_FOLDER, SWAN_HASHED_FOLDER } from '../constants/paths.js';
import { SWAN_BASE_CDN_URL } from '../constants/domains.js';

function getSwanAssetFolderName(folder) {
    switch(folder){
        case SwanAssetFolders.FAVICONS:
            return 'favicons';
        case SwanAssetFolders.POLYFILLS:
            return 'polyfills';
        case SwanAssetFolders.FONTS:
            return 'fonts';
        case SwanAssetFolders.ICONS:
            return 'icons';
        case SwanAssetFolders.IMAGES:
            return 'images';
        case SwanAssetFolders.JS:
            return 'js';
        case SwanAssetFolders.STYLES:
            return 'styles';
        case SwanAssetFolders.THEMES:
            return 'themes';
    }
}
function getVersionPrefix(pathType = SwanPathTypeEnum.hashed) {
    if (isTestEnv()) {
        return 'pkg-folder-test';
    }
    if (pathType === SwanPathTypeEnum.versioned) return SWAN_VERSIONED_FOLDER;
    return SWAN_HASHED_FOLDER;
}
function manifestResolve(manifest, key, folder, pathType = SwanPathTypeEnum.hashed, swanAssetBaseUrl = SWAN_BASE_CDN_URL) {
    const manifestConfig = manifest[key];
    const fileName = manifestConfig[pathType] || manifestConfig.hashed || manifestConfig.versioned;
    if (fileName) {
        const versionPrefix = getVersionPrefix(pathType);
        const folderName = getSwanAssetFolderName(folder);
        return `${swanAssetBaseUrl || ''}${versionPrefix}/${folderName}/${fileName}`;
    }
    return null;
}
function getSameKeyValueMapForManifest(manifest) {
    return Object.fromEntries(Object.keys(manifest).map((k)=>[
            k,
            k
        ]));
}
function polyfillResolve(fileName, swanAssetBaseUrl = SWAN_BASE_CDN_URL) {
    const folderName = getSwanAssetFolderName(SwanAssetFolders.POLYFILLS);
    return `${swanAssetBaseUrl}${SWAN_PUBLIC_ASSET_FOLDER}/${folderName}/${fileName}`;
}

export { getSameKeyValueMapForManifest, getSwanAssetFolderName, manifestResolve, polyfillResolve };
